export default "__VITE_ASSET__3e00fe7a__"